import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Spacings } from '@styles/index';
import Sections from './Sections';

const SectionsWrapper = styled.div`
  display: grid;
  grid-column-gap: ${Spacings.SPACING_10B};
  padding: ${Spacings.SPACING_2B} ${Spacings.SPACING_12B};
  grid-template: 1fr / repeat(3, max-content);
  justify-content: center;
  background: var(--color-base-1);
  z-index: 15;
`;

const HeaderSectionsMobile = ({ headerRefs }) => {
  return (
    <SectionsWrapper>
      <Sections headerRefs={headerRefs} />
    </SectionsWrapper>
  );
};

HeaderSectionsMobile.propTypes = {
  headerRefs: PropTypes.objectOf(PropTypes.object).isRequired
};

export default HeaderSectionsMobile;
